const registerAnimations = () => {
  const $ = window.$;

  var windowHeight = window.innerHeight;
  var windowWidth = window.innerWidth;
  var prepare = windowHeight / 3;

  // sec2
  $(document).ready(function () {
    var windowScroll = $(window).scrollTop();
    if ($('.sec2 .figure').length) {
      var sec2 = $('.sec2 .figure').offset().top;

      if (windowScroll + windowHeight - prepare * 0 > sec2) {
        $('.sec2 .shoe-colors').addClass('animate fadeIn');
      }
      $(window).on('scroll', function () {
        windowScroll = $(window).scrollTop();
        sec2 = $('.sec2').offset().top;
        if (windowScroll + windowHeight - prepare * 0 > sec2) {
          $('.sec2 .shoe-colors').addClass('animate fadeIn');
        }
      });
    }
  });

  //sec3
  $(document).ready(function () {
    var windowScroll = $(window).scrollTop();
    if ($('.sec3').length) {
      var footbed = $('.sec3').offset().top;

      if (windowScroll + windowHeight - prepare * 2 > footbed) {
        $('.sec3 .shoe').addClass('fadeIn');
        $('.sec3 .sole-features').addClass('animate');
      }
      $(window).on('scroll', function () {
        windowScroll = $(window).scrollTop();
        footbed = $('.sec3').offset().top;
        if (windowScroll + windowHeight - prepare * 1.5 > footbed) {
          $('.sec3 .shoe').addClass('fadeIn');
          $('.sec3 .sole-features').addClass('animate');
        }
        // console.log(footbed);
      });
    }
  });

  //sec6
  $(document).ready(function () {
    var windowScroll = $(window).scrollTop();
    if ($('.sec6').length) {
      var sec6 = $('.sec6').offset().top;

      if (windowScroll + windowHeight - prepare * 2 > sec6) {
        $('.sec6 .animated').addClass('fadeInRight');
      }
      $(window).on('scroll', function () {
        windowScroll = $(window).scrollTop();
        sec6 = $('.sec6').offset().top;
        if (windowScroll + windowHeight - prepare * 1.25 > sec6) {
          $('.sec6 .animated').addClass('fadeInRight');
        }
        //console.log(sec6);
      });
    }
  });

  //sec7
  $(document).ready(function () {
    var windowScroll = $(window).scrollTop();
    if ($('.sec7').length) {
      var footbed = $('.sec7').offset().top;

      if (windowScroll + windowHeight - prepare * 2 > footbed) {
        $('.sec7 .comfort-1').addClass('fadeInDown');
      }
      $(window).on('scroll', function () {
        windowScroll = $(window).scrollTop();
        footbed = $('.sec7').offset().top;
        if (windowScroll + windowHeight - prepare * 1.5 > footbed) {
          $('.sec7 .comfort-1').addClass('fadeInDown');
        }
        // console.log(footbed);
      });
    }
  });

  //sec8

  $(document).ready(function () {
    var windowScroll = $(window).scrollTop();
    if ($('.sec8').length) {
      var sec8 = $('.sec8').offset().top;

      if (windowScroll + windowHeight - prepare * 2 > sec8) {
        $('.sec8 .animated').addClass('fadeInRight');
      }
      $(window).on('scroll', function () {
        windowScroll = $(window).scrollTop();
        sec8 = $('.sec8').offset().top;
        if (windowScroll + windowHeight - prepare * 1.5 > sec8) {
          $('.sec8 .animated').addClass('fadeInRight');
        }
        //console.log(sec8);
      });
    }
  });
};

export default registerAnimations;
